const post = {
  id: "bordle",
  title: "Bordle",
  publication: "Portfolio, 2025",
  date: "2025-08-01",
  summary: "A Python terminal game where you expand a contiguous chain of countries using only land borders, with ASCII art, a timer, and three lives.",
  content: `

## Bordle

Bordle is a terminal game I built in Python. It drops you in a random country and asks you to expand your territory by naming countries that share a land border with any country you've already claimed. You have three lives. Get a country wrong, or name one that isn't adjacent, and you lose one.

The goal is to build the longest possible contiguous chain of countries before your lives run out.

\`\`\`
Enter a country that borders
Afghanistan, Pakistan, India, Nepal, Bhutan, China: Bangladesh
Bangladesh is correct! You have 3 lives and a score of 6
\`\`\`

When the game ends, it tells you your score, your final list of countries, how long you played, and crucially, which countries you *could* have picked next. That last part stings.

### What Made It Interesting to Build

The border data was the hardest part in theory: a dictionary of ~180 countries, each with their full list of land neighbours. What would once have taken hours of hand-curation, I just pasted into Claude and it produced the whole thing in seconds. It still meant making judgment calls on contested borders: Does Kosovo border Serbia? (Yes.) Is Western Sahara a country? (Included it.) What about South Sudan? Getting this right mattered because a wrong entry silently breaks the game logic.


### Technologies Used

- **Python** - core game loop, input handling, scoring
- **borders.py** - LLM-curated adjacency dictionary for ~180 countries
- **ASCII art title** - because why not

[View on GitHub](https://github.com/macaswalker/bordle)

This took me around 2 hours to build in 2025. When will LLMs be able to do this one shot?

---
`
};

export default post;
